module.exports = __webpack_public_path__ + "static/media/arrow-left-circle.30f11b52.png";